/* Samsara — Cutoff Popup W23 controller */
(function () {
  'use strict';

  const popup = document.querySelector('[data-cutoff-popup]');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'samsara_cutoff_w23_seen';

  // Check if user already saw popup
  let seen = false;
  try {
    seen = window.localStorage.getItem(storageKey) === '1';
  } catch (e) {
    // localStorage may be blocked; default to showing once per session
    seen = false;
  }

  if (seen) {
    popup.parentNode && popup.parentNode.removeChild(popup);
    return;
  }

  // Show popup after small delay (let page settle, avoid CLS on initial paint)
  const showDelay = 800;
  let shown = false;

  function show() {
    if (shown) return;
    shown = true;
    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // Focus close button for a11y
    const closeBtn = popup.querySelector('[data-cutoff-popup-close]');
    if (closeBtn && closeBtn.focus) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }
  }

  function close() {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
    try { window.localStorage.setItem(storageKey, '1'); } catch (e) { /* noop */ }
    // Remove from DOM after close to free resources
    setTimeout(function () {
      popup.parentNode && popup.parentNode.removeChild(popup);
    }, 100);
  }

  // Bind close triggers
  const closeTargets = popup.querySelectorAll('[data-cutoff-popup-close]');
  closeTargets.forEach(function (el) {
    el.addEventListener('click', close);
  });

  // ESC key closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hasAttribute('hidden')) {
      close();
    }
  });

  // Show after delay
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(show, showDelay);
    });
  } else {
    setTimeout(show, showDelay);
  }
})();
